module.exports = __webpack_public_path__ + "img/rb-leipzig.8df4ce87.png";